export default {
	UNPAID: 'UNPAID',
	PAID_WITHIN_FYSCAL_YEAR: 'PAID_WITHIN_FYSCAL_YEAR',
	PAID_AFTER_FYSCAL_YEAR: 'PAID_AFTER_FYSCAL_YEAR'
};
